import React from 'react';
import cn from 'classnames';
import { Color } from '../constants';

export function InfoItem({ icon, text, color }) {
  return (
    <div className="device-info-content__item device-info-content-item">
      <div
        className={cn('device-info-content-item__icon', {
          'device-info-content-item__icon--success': color === Color.SUCCESS,
          'device-info-content-item__icon--danger': color === Color.DANGER,
          'device-info-content-item__icon--warning': color === Color.WARNING,
        })}
      >
        {icon}
      </div>
      <div className="device-info-content-item__text">{text}</div>
    </div>
  );
}

export default InfoItem;
